import React, { useState } from 'react';

const LoadCampaignDataButton = ({ 
    clientCampaigns, 
    loadAllCampaignsWithHistoryAndOpenBillingData,
    triggerTableRerender,
    tabName = 'Campaign'
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleLoadFullData = () => {
        setIsLoading(true);
        loadAllCampaignsWithHistoryAndOpenBillingData((response) => {
            setIsLoading(false);
            if (triggerTableRerender) {
                triggerTableRerender();
            }
        });
    };

    const hasData = clientCampaigns && Object.keys(clientCampaigns).length > 0;

    // Hide the component when data is loaded
    if (hasData) {
        return null;
    }

    return (
        <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #dee2e6' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                    <strong>{tabName} Data</strong>
                    <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#6c757d' }}>
                        Click the button below to load full campaign data with history and billing information.
                    </p>
                </div>
                <button 
                    onClick={handleLoadFullData}
                    disabled={isLoading}
                    style={{
                        backgroundColor: isLoading ? '#6c757d' : '#007bff',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        minWidth: '150px'
                    }}
                    onMouseOver={(e) => {
                        if (!isLoading) {
                            e.target.style.backgroundColor = '#0056b3';
                        }
                    }}
                    onMouseOut={(e) => {
                        if (!isLoading) {
                            e.target.style.backgroundColor = '#007bff';
                        }
                    }}
                >
                    {isLoading ? 'Loading...' : 'Load Full Campaign Data'}
                </button>
            </div>
        </div>
    );
};

export default LoadCampaignDataButton;


